import { useFormikContext } from "formik";
import { useEffect } from "react";
const FormErrorNotification = () => {
    const { isValid, isValidating, isSubmitting, errors } = useFormikContext();
    useEffect(() => {
        if (!isValid && !isValidating && isSubmitting) {
            //alert("NOPE")
        }
    }, [isSubmitting, isValid, isValidating]);
    return null;
};
export default FormErrorNotification;
